// Mock data for users
export const mockUsers = [
  {
    id: '1',
    name: 'John Doe',
    email: 'john.doe@example.com',
    phone: '+1234567890',
    status: 'active',
    joinDate: '2023-01-15',
    address: '123 Main St',
    city: 'New York',
    country: 'USA',
  },
  {
    id: '2',
    name: 'Jane Smith',
    email: 'jane.smith@example.com',
    phone: '+1987654321',
    status: 'active',
    joinDate: '2023-02-20',
    address: '456 Oak Ave',
    city: 'Los Angeles',
    country: 'USA',
  },
  {
    id: '3',
    name: 'Bob Johnson',
    email: 'bob.johnson@example.com',
    phone: '+1122334455',
    status: 'inactive',
    joinDate: '2023-03-10',
    address: '789 Pine St',
    city: 'Chicago',
    country: 'USA',
  },
];

// Mock data for subscriptions
export const mockSubscriptions = [
  {
    id: '1',
    name: 'Basic Plan',
    price: 29.99,
    duration: 30,
    durationType: 'days',
    features: ['Access to gym equipment', 'Locker access'],
    status: 'active',
    description: 'Basic gym access with limited features',
  },
  {
    id: '2',
    name: 'Premium Plan',
    price: 49.99,
    duration: 30,
    durationType: 'days',
    features: [
      'Access to gym equipment',
      'Locker access',
      'Group classes',
      'Personal trainer (1 session)',
    ],
    status: 'active',
    description: 'Premium access with additional features',
  },
  {
    id: '3',
    name: 'Annual Plan',
    price: 499.99,
    duration: 1,
    durationType: 'years',
    features: [
      'Access to gym equipment',
      'Locker access',
      'Group classes',
      'Personal trainer (12 sessions)',
      'Nutrition consultation',
    ],
    status: 'active',
    description: 'Annual subscription with all features included',
  },
];

// Mock data for user subscriptions
export const mockUserSubscriptions = [
  {
    id: '1',
    userId: '1',
    subscriptionId: '2',
    startDate: '2023-05-01',
    endDate: '2023-06-01',
    status: 'active',
    autoRenew: true,
  },
  {
    id: '2',
    userId: '2',
    subscriptionId: '3',
    startDate: '2023-04-15',
    endDate: '2024-04-15',
    status: 'active',
    autoRenew: false,
  },
];

// Mock data for payments
export const mockPayments = [
  {
    id: '1',
    userId: '1',
    amount: 49.99,
    date: '2023-05-01',
    method: 'Credit Card',
    status: 'paid',
    subscriptionId: '2',
    transactionId: 'txn_123456',
    gymId: 'gym1',
  },
  {
    id: '2',
    userId: '2',
    amount: 499.99,
    date: '2023-04-15',
    method: 'PayPal',
    status: 'paid',
    subscriptionId: '3',
    transactionId: 'txn_789012',
    gymId: 'gym2',
  },
  {
    id: '3',
    userId: '1',
    amount: 29.99,
    date: '2023-06-01',
    method: 'Credit Card',
    status: 'paid',
    subscriptionId: '1',
    transactionId: 'txn_345678',
    gymId: 'gym1',
  },
  {
    id: '4',
    userId: '3',
    amount: 49.99,
    date: '2023-05-20',
    method: 'PayPal',
    status: 'pending',
    subscriptionId: '2',
    transactionId: 'txn_901234',
    gymId: 'gym2',
  },
  {
    id: '5',
    userId: '2',
    amount: 29.99,
    date: '2023-06-10',
    method: 'Credit Card',
    status: 'paid',
    subscriptionId: '1',
    transactionId: 'txn_567890',
    gymId: 'gym1',
  },
];

// Mock data for gyms
export const mockGyms = [
  {
    id: '1',
    name: 'Gym Tirane',
    address: 'Rruga Myslym Shyri, Nr. 50',
    city: 'Tirane',
    country: 'Albania',
    phone: '+355 69 123 4567',
    email: 'tirane@Gym.com',
    status: 'active',
    workingHours: 'Mon-Fri: 6:00-22:00, Sat-Sun: 8:00-20:00',
    facilities: [
      'Cardio Equipment',
      'Weight Training',
      'Group Classes',
      'Sauna',
      'Locker Rooms',
    ],
  },
  {
    id: '2',
    name: 'Gym Fier',
    address: 'Rruga Jakov Xoxa, Nr. 25',
    city: 'Fier',
    country: 'Albania',
    phone: '+355 69 987 6543',
    email: 'fier@Gym.com',
    status: 'active',
    workingHours: 'Mon-Fri: 6:00-22:00, Sat-Sun: 8:00-20:00',
    facilities: [
      'Cardio Equipment',
      'Weight Training',
      'Pool',
      'Spa',
      'Locker Rooms',
    ],
  },
  {
    id: '3',
    name: 'Gym Green Coast',
    address: 'Green Coast Resort, Palasa',
    city: 'Vlorë',
    country: 'Albania',
    phone: '+355 69 456 7890',
    email: 'greencoast@Gym.com',
    status: 'active',
    workingHours: 'Mon-Sun: 7:00-21:00',
    facilities: [
      'Cardio Equipment',
      'Weight Training',
      'Outdoor Pool',
      'Beach Access',
      'Luxury Spa',
      'Locker Rooms',
    ],
  },
];

// Mock data for reviews
export const mockReviews = [
  {
    id: '1',
    userId: '1',
    gymId: '1',
    rating: 4.5,
    date: '2023-06-10',
    comment:
      'Great gym with excellent equipment. The staff is very friendly and helpful.',
    status: 'approved',
  },
  {
    id: '2',
    userId: '2',
    gymId: '2',
    rating: 5,
    date: '2023-06-15',
    comment:
      'Amazing facilities and great atmosphere. The trainers are very knowledgeable.',
    status: 'approved',
  },
  {
    id: '3',
    userId: '3',
    gymId: '1',
    rating: 3.5,
    date: '2023-06-20',
    comment: 'Good gym but can get crowded during peak hours.',
    status: 'pending',
  },
];

// Mock data for news and offers
export const mockNewsPosts = [
  {
    id: '1',
    title: 'New Fitness Classes Starting Next Month',
    content:
      "We're excited to announce new fitness classes starting next month, including HIIT, Yoga, and Pilates.",
    type: 'news',
    publishDate: '2023-07-01',
    expiryDate: '2023-08-01',
    status: 'active',
    image: '/placeholder.svg?height=200&width=400',
  },
  {
    id: '2',
    title: 'Summer Special: 20% Off Annual Memberships',
    content:
      'Get 20% off annual memberships when you sign up before August 31st. Use code SUMMER20 at checkout.',
    type: 'offer',
    publishDate: '2023-07-15',
    expiryDate: '2023-08-31',
    status: 'active',
    image: '/placeholder.svg?height=200&width=400',
    discount: '20%',
    discountCode: 'SUMMER20',
  },
  {
    id: '3',
    title: 'Gym Renovation Complete',
    content:
      'Our downtown location renovation is now complete. Come check out our new equipment and facilities!',
    type: 'news',
    publishDate: '2023-06-15',
    expiryDate: '2023-07-15',
    status: 'inactive',
    image: '/placeholder.svg?height=200&width=400',
  },
];

// Mock data for chat conversations
export const mockChatConversations = [
  {
    id: '1',
    userId: '1',
    userName: 'John Doe',
    userEmail: 'john.doe@example.com',
    lastActive: new Date().toISOString(),
    unreadCount: 2,
    messages: [
      {
        id: '1',
        senderId: '1',
        senderType: 'user',
        message: 'Hi, I have a question about my membership.',
        timestamp: new Date(Date.now() - 3600000).toISOString(),
        read: true,
      },
      {
        id: '2',
        senderId: 'admin',
        senderType: 'admin',
        message: 'Hello John, how can I help you with your membership?',
        timestamp: new Date(Date.now() - 3500000).toISOString(),
        read: true,
      },
      {
        id: '3',
        senderId: '1',
        senderType: 'user',
        message: "I'd like to upgrade to the premium plan. How do I do that?",
        timestamp: new Date(Date.now() - 3400000).toISOString(),
        read: true,
      },
      {
        id: '4',
        senderId: '1',
        senderType: 'user',
        message:
          'Also, will I get a refund for the remaining days of my current plan?',
        timestamp: new Date(Date.now() - 60000).toISOString(),
        read: false,
      },
    ],
  },
  {
    id: '2',
    userId: '2',
    userName: 'Jane Smith',
    userEmail: 'jane.smith@example.com',
    lastActive: new Date(Date.now() - 86400000).toISOString(),
    unreadCount: 1,
    messages: [
      {
        id: '1',
        senderId: '2',
        senderType: 'user',
        message:
          "Hello, I'm having trouble accessing the gym with my key card.",
        timestamp: new Date(Date.now() - 172800000).toISOString(),
        read: true,
      },
      {
        id: '2',
        senderId: 'admin',
        senderType: 'admin',
        message: "Hi Jane, I'm sorry to hear that. When did this issue start?",
        timestamp: new Date(Date.now() - 172700000).toISOString(),
        read: true,
      },
      {
        id: '3',
        senderId: '2',
        senderType: 'user',
        message:
          "It started yesterday. I tried multiple times but it wouldn't work.",
        timestamp: new Date(Date.now() - 86400000).toISOString(),
        read: false,
      },
    ],
  },
  {
    id: '3',
    userId: '3',
    userName: 'Bob Johnson',
    userEmail: 'bob.johnson@example.com',
    lastActive: new Date(Date.now() - 259200000).toISOString(),
    unreadCount: 0,
    messages: [
      {
        id: '1',
        senderId: '3',
        senderType: 'user',
        message: "I'd like to cancel my membership. How do I proceed?",
        timestamp: new Date(Date.now() - 432000000).toISOString(),
        read: true,
      },
      {
        id: '2',
        senderId: 'admin',
        senderType: 'admin',
        message:
          "Hello Bob, I'm sorry to hear you want to cancel. You can cancel through your account settings or visit the gym in person. May I ask why you're cancelling?",
        timestamp: new Date(Date.now() - 431000000).toISOString(),
        read: true,
      },
      {
        id: '3',
        senderId: '3',
        senderType: 'user',
        message: "I'm moving to another city. Thanks for the information.",
        timestamp: new Date(Date.now() - 259200000).toISOString(),
        read: true,
      },
    ],
  },
];

// Mock data for check-ins
export const mockCheckIns = [
  {
    id: '1',
    userId: '1',
    userName: 'John Doe',
    gymId: '1',
    gymName: 'Gym Downtown',
    checkInTime: new Date(Date.now() - 3600000).toISOString(),
    checkOutTime: new Date(Date.now() - 1800000).toISOString(),
    status: 'completed',
  },
  {
    id: '2',
    userId: '2',
    userName: 'Jane Smith',
    gymId: '2',
    gymName: 'Gym Uptown',
    checkInTime: new Date(Date.now() - 7200000).toISOString(),
    checkOutTime: new Date(Date.now() - 5400000).toISOString(),
    status: 'completed',
  },
  {
    id: '3',
    userId: '1',
    userName: 'John Doe',
    gymId: '1',
    gymName: 'Gym Downtown',
    checkInTime: new Date().toISOString(),
    checkOutTime: null,
    status: 'active',
  },
];

// Generate QR code data for users
export const generateUserQRData = (userId: string) => {
  return {
    userId,
    timestamp: new Date().toISOString(),
    token: `token_${userId}_${Date.now()}`,
  };
};

// Mock data for staff
export const mockStaff = [
  {
    id: '1',
    name: 'Arben Krasniqi',
    email: 'arben.krasniqi@Gym.com',
    phone: '+355 69 123 4567',
    position: 'Manager',
    gymId: '1',
    hireDate: '2022-01-10',
    status: 'active',
    address: 'Rruga Bardhyl, Nr. 15, Tirane',
    certifications: ['Personal Trainer', 'Nutrition Specialist'],
    workingHours: 'Mon-Fri: 9:00-17:00',
  },
  {
    id: '2',
    name: 'Elira Hoxha',
    email: 'elira.hoxha@Gym.com',
    phone: '+355 69 234 5678',
    position: 'Fitness Trainer',
    gymId: '1',
    hireDate: '2022-03-15',
    status: 'active',
    address: 'Rruga Kavajes, Nr. 120, Tirane',
    certifications: ['Fitness Instructor', 'Yoga Teacher'],
    workingHours: 'Mon-Fri: 7:00-15:00',
  },
  {
    id: '3',
    name: 'Dritan Berisha',
    email: 'dritan.berisha@Gym.com',
    phone: '+355 69 345 6789',
    position: 'Manager',
    gymId: '2',
    hireDate: '2022-02-01',
    status: 'active',
    address: 'Rruga Jakov Xoxa, Nr. 30, Fier',
    certifications: ['Business Management', 'First Aid'],
    workingHours: 'Mon-Fri: 9:00-17:00',
  },
  {
    id: '4',
    name: 'Teuta Shala',
    email: 'teuta.shala@Gym.com',
    phone: '+355 69 456 7890',
    position: 'Fitness Trainer',
    gymId: '2',
    hireDate: '2022-04-05',
    status: 'active',
    address: 'Rruga Dervish Hekali, Nr. 5, Fier',
    certifications: ['Personal Trainer', 'CrossFit Level 1'],
    workingHours: 'Tue-Sat: 14:00-22:00',
  },
  {
    id: '5',
    name: 'Genti Malaj',
    email: 'genti.malaj@Gym.com',
    phone: '+355 69 567 8901',
    position: 'Manager',
    gymId: '3',
    hireDate: '2022-01-20',
    status: 'active',
    address: 'Green Coast Resort, Palasa, Vlorë',
    certifications: ['Hospitality Management', 'Fitness Management'],
    workingHours: 'Mon-Fri: 9:00-17:00',
  },
  {
    id: '6',
    name: 'Rina Prifti',
    email: 'rina.prifti@Gym.com',
    phone: '+355 69 678 9012',
    position: 'Yoga Instructor',
    gymId: '3',
    hireDate: '2022-05-10',
    status: 'active',
    address: 'Rruga Ismail Qemali, Nr. 45, Vlorë',
    certifications: ['Yoga Alliance RYT-200', 'Meditation Instructor'],
    workingHours: 'Wed-Sun: 8:00-16:00',
  },
  {
    id: '7',
    name: 'Besnik Dervishi',
    email: 'besnik.dervishi@Gym.com',
    phone: '+355 69 789 0123',
    position: 'Maintenance',
    gymId: '1',
    hireDate: '2022-06-15',
    status: 'active',
    address: 'Rruga Sami Frashëri, Nr. 60, Tirane',
    certifications: ['Equipment Maintenance', 'Facility Management'],
    workingHours: 'Mon-Fri: 6:00-14:00',
  },
  {
    id: '8',
    name: 'Mirela Gjoka',
    email: 'mirela.gjoka@Gym.com',
    phone: '+355 69 890 1234',
    position: 'Receptionist',
    gymId: '3',
    hireDate: '2022-07-01',
    status: 'inactive',
    address: 'Rruga Naim Frashëri, Nr. 25, Vlorë',
    certifications: ['Customer Service', 'First Aid'],
    workingHours: 'Mon-Fri: 14:00-22:00',
  },
];

// Financial data
export const mockFinancialData = [
  {
    date: '2023-01-15',
    gymId: 'gym1',
    revenue: 25000,
    expenses: 18000,
    activeSubscriptions: 150,
    subscriptionRevenue: {
      basic: 5000,
      premium: 12000,
      family: 6000,
      corporate: 2000,
    },
    subscriptionCounts: {
      basic: 50,
      premium: 60,
      family: 30,
      corporate: 10,
    },
    expenseBreakdown: {
      salaries: 10000,
      rent: 4000,
      equipment: 2000,
      utilities: 1000,
      marketing: 1000,
    },
  },
  {
    date: '2023-02-15',
    gymId: 'gym1',
    revenue: 27000,
    expenses: 19000,
    activeSubscriptions: 160,
    subscriptionRevenue: {
      basic: 5200,
      premium: 13000,
      family: 6500,
      corporate: 2300,
    },
    subscriptionCounts: {
      basic: 52,
      premium: 65,
      family: 32,
      corporate: 11,
    },
    expenseBreakdown: {
      salaries: 10500,
      rent: 4000,
      equipment: 2500,
      utilities: 1000,
      marketing: 1000,
    },
  },
  {
    date: '2023-03-15',
    gymId: 'gym1',
    revenue: 29000,
    expenses: 20000,
    activeSubscriptions: 170,
    subscriptionRevenue: {
      basic: 5500,
      premium: 14000,
      family: 7000,
      corporate: 2500,
    },
    subscriptionCounts: {
      basic: 55,
      premium: 70,
      family: 35,
      corporate: 10,
    },
    expenseBreakdown: {
      salaries: 11000,
      rent: 4000,
      equipment: 3000,
      utilities: 1000,
      marketing: 1000,
    },
  },
  {
    date: '2023-04-15',
    gymId: 'gym2',
    revenue: 18000,
    expenses: 14000,
    activeSubscriptions: 120,
    subscriptionRevenue: {
      basic: 4000,
      premium: 8000,
      family: 4000,
      corporate: 2000,
    },
    subscriptionCounts: {
      basic: 40,
      premium: 40,
      family: 20,
      corporate: 20,
    },
    expenseBreakdown: {
      salaries: 8000,
      rent: 3000,
      equipment: 1000,
      utilities: 1000,
      marketing: 1000,
    },
  },
  {
    date: '2023-05-15',
    gymId: 'gym2',
    revenue: 19000,
    expenses: 14500,
    activeSubscriptions: 125,
    subscriptionRevenue: {
      basic: 4200,
      premium: 8500,
      family: 4300,
      corporate: 2000,
    },
    subscriptionCounts: {
      basic: 42,
      premium: 42,
      family: 21,
      corporate: 20,
    },
    expenseBreakdown: {
      salaries: 8000,
      rent: 3000,
      equipment: 1500,
      utilities: 1000,
      marketing: 1000,
    },
  },
];

// Expense categories
export const mockExpenseCategories = [
  { id: 'salaries', color: '#4ade80' },
  { id: 'rent', color: '#f87171' },
  { id: 'equipment', color: '#60a5fa' },
  { id: 'utilities', color: '#fbbf24' },
  { id: 'marketing', color: '#a78bfa' },
];

// Subscription types
export const mockSubscriptionTypes = [
  { id: 'basic', price: 29.99 },
  { id: 'premium', price: 49.99 },
  { id: 'family', price: 79.99 },
  { id: 'corporate', price: 99.99 },
];

// Payment history
export const mockPaymentHistory = [
  {
    id: 'PAY-1234',
    date: '2023-05-15',
    userName: 'John Doe',
    method: 'Credit Card',
    status: 'completed',
    amount: 180,
    gymId: 'gym1',
  },
  {
    id: 'PAY-1235',
    date: '2023-05-14',
    userName: 'Jane Smith',
    method: 'PayPal',
    status: 'completed',
    amount: 220,
    gymId: 'gym1',
  },
  {
    id: 'PAY-1236',
    date: '2023-05-13',
    userName: 'Mike Johnson',
    method: 'Credit Card',
    status: 'pending',
    amount: 80,
    gymId: 'gym1',
  },
  {
    id: 'PAY-1237',
    date: '2023-05-12',
    userName: 'Sarah Williams',
    method: 'Bank Transfer',
    status: 'completed',
    amount: 180,
    gymId: 'gym1',
  },
  {
    id: 'PAY-1238',
    date: '2023-05-11',
    userName: 'David Brown',
    method: 'Credit Card',
    status: 'failed',
    amount: 80,
    gymId: 'gym1',
  },
  {
    id: 'PAY-1239',
    date: '2023-05-10',
    userName: 'Emily Davis',
    method: 'PayPal',
    status: 'completed',
    amount: 220,
    gymId: 'gym1',
  },
  {
    id: 'PAY-1240',
    date: '2023-05-15',
    userName: 'Alex Wilson',
    method: 'Credit Card',
    status: 'completed',
    amount: 180,
    gymId: 'gym2',
  },
  {
    id: 'PAY-1241',
    date: '2023-05-14',
    userName: 'Lisa Taylor',
    method: 'PayPal',
    status: 'completed',
    amount: 80,
    gymId: 'gym2',
  },
  {
    id: 'PAY-1242',
    date: '2023-05-13',
    userName: 'Robert Martin',
    method: 'Bank Transfer',
    status: 'pending',
    amount: 80,
    gymId: 'gym2',
  },
  {
    id: 'PAY-1243',
    date: '2023-05-12',
    userName: 'Jennifer Clark',
    method: 'Credit Card',
    status: 'completed',
    amount: 180,
    gymId: 'gym2',
  },
];

export const mockPaymentsData = [
  {
    id: 'PAY-1234',
    date: '2023-05-01',
    userId: 'user1',
    userName: 'John Doe',
    amount: 49.99,
    method: 'Credit Card',
    status: 'completed',
    gymId: 'gym1',
  },
  {
    id: 'PAY-1235',
    date: '2023-05-02',
    userId: 'user2',
    userName: 'Jane Smith',
    amount: 29.99,
    method: 'PayPal',
    status: 'completed',
    gymId: 'gym1',
  },
  {
    id: 'PAY-1236',
    date: '2023-05-03',
    userId: 'user3',
    userName: 'Bob Johnson',
    amount: 79.99,
    method: 'Bank Transfer',
    status: 'pending',
    gymId: 'gym2',
  },
  {
    id: 'PAY-1237',
    date: '2023-05-04',
    userId: 'user4',
    userName: 'Alice Brown',
    amount: 99.99,
    method: 'Credit Card',
    status: 'completed',
    gymId: 'gym2',
  },
  {
    id: 'PAY-1238',
    date: '2023-05-05',
    userId: 'user5',
    userName: 'Charlie Wilson',
    amount: 49.99,
    method: 'PayPal',
    status: 'failed',
    gymId: 'gym1',
  },
];
